const CartActions = {
  CART_UPDATE: "CART_UPDATE",
  USE_POINTS: "USE_POINTS",
};

export default CartActions;
